
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/airport-info/security",
      function () {
        return require("private-next-pages/[locale]/airport-info/security.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/airport-info/security"])
      });
    }
  